import React from 'react';
import { Header } from './modules/HeaderContent';
import { Footer } from './modules/FooterContent';
import '../assets/css/eqreturnoneapp.css';
import '../assets/css/homepage.css';
import {Title,Body} from '@vds/typography';
import {Line} from '@vds/lines';
import styled from 'styled-components';
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import PDFImage from "../assets/resources/images/pdficon.png";
import CalendarImage from "../assets/resources/images/calendaricon.png";
import {setNativeTitleWithNavigation, getValuesFromUserAgent, nativeBackAction,versionCompare,nativeHideTopBar,updateTab} from "../actions/native";
import { getOS,isNullOrUndefined } from './modules/CommonFunctions';
import { RTCICall } from "./modules/RTCICall";
import EQReturnModalDialog from './modules/EQReturnOrderPopup';
const StyledLineLight = styled.div `height:2px`;
import CaretImage from "../assets/resources/images/caret.png";
import { ORDER_NUMBER_CONTENT } from '../constants/dialogsContent';

const StyledSubcontent = styled.div`padding-top:8px; `
const StyledLine = styled.div`padding-top:16px`
const StyledMainContent = styled.div`padding-left:17px`
const MainContainer = styled.div`display:flex`
//ONEAPP ER page
class EquipmentReturnPageOneApp extends React.Component {
        constructor(props) {
            super(props);
            this.dialogRef = React.createRef();
            this.ischkValidUser = false;
            if(window.userinfo !== null) {this.ischkValidUser = true;}
            this.isValidUser = true;
            // if(window.userinfo !== null) {this.isValidUser = true;} 
            if(this.ischkValidUser){
                this.state={
                    validUser: true,
                    signInStaticData: {},
                    signInDynamicData: {},
                    NEED_TO_KNOW_CONTENT:  JSON.parse(window.erStaticData).rtelist[0].richText 
                }
            }
            else{
                this.state = {
                    validUser: false,
                    /*For running in local */
                    // validUser: true,
                    signInStaticData: {},
                    signInDynamicData: {},
                    nCogData: {},			
                    NEED_TO_KNOW_CONTENT: (document.cookie.indexOf('userinfo') > -1) ? JSON.parse(window.erStaticData).rtelist[0].richText : ''
                    
                } 
             }  
             this.PDFImage  = PDFImage;
             this.CalendarImage = CalendarImage;
             this.careticon = CaretImage;
            //  this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
             this.signInStaticData = {};
             this.successCallBack = this.ufdSuccessCallback.bind(this);
             this.failureCallBack = this.ufdFailureCallBack.bind(this);
             this.signInDynamicData = {};
             this.isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false;
             this.isDropOffPage = false;
             this.printLabelContent = "";
        }
        componentDidMount() {

                const{channelId,version}=getValuesFromUserAgent(navigator.userAgent)
                if (
                  (versionCompare(version, "11.1.0") &&
                    channelId.toUpperCase() === "VZW-MFA-IOS") ||
                  (versionCompare(version, "18.2.0") &&
                    channelId.toUpperCase() === "VZW-MFA-ANDROID")
                ) {
                  nativeBackAction("Equipment return", true, false);
                } else {
                  setNativeTitleWithNavigation("Equipment return", true);
                  nativeHideTopBar(true);
                  updateTab(false);
                }
                let operatingSystem = getOS();
                        let intent = "";
                        let args = {
                                equipment_name: "Equipment returns",
                                intentCategory: "NBA_DISPLAY",
                                activityCategory: "NBA_DISPLAY",
                                intent: intent,
                                app_n_channel: "NBA-ESUPPORT",
                                os: operatingSystem,
                                pegaSessionID: "",
                                userid: (this.isValidUser) ? window.userinfo.userId : "",
                                visionID: (this.isValidUser) ? window.userinfo.visionId : "",
                                accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
                        };	
                        if (window.userinfo !== null && Object.keys(this.state.signInStaticData).length === 0 && Object.keys(this.state.signInDynamicData).length === 0) {
                                this.signInStaticData = Object.assign(this.signInStaticData, this.convertStringToObject(this.props.StaticData));
                                this.signInDynamicData = Object.assign(this.signInDynamicData, this.convertStringToObject(this.props.DynamicData));
                                if (Object.keys(this.signInStaticData).length > 0 && !isNullOrUndefined(this.signInDynamicData.orderDetails) && Object.keys(this.signInDynamicData.orderDetails).length > 0) {
                                        if (this.signInDynamicData.orderDetails.ReturnType !== "FRK") {
                                                this.isDropOffPage = true;
                                        }
                                }
                                this.setState({
                                        validUser: true,
                                        signInStaticData: this.signInStaticData,
                                        signInDynamicData: this.signInDynamicData,
                                        nCogData: this.props.NcogData
                                        
                                })
                        }
                        //  document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this), false);
                        // return () => {
                        // document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
                        // };
                }
            getERStorelocatorUrl() {
                        return "https://www.verizon.com/stores/search-results/?fios=equipment";
                }
            getStorelocatorUrl() {
                        return "https://www.verizon.com/home/storelocator/";
                }
                //storelocator url change
            PDFViewer(e){
                let pdfContent = "";
                        if (e !== null && e !== undefined) {
                    pdfContent = JSON.parse(window.erStaticData).rtelist[0].richText; 
                    //pdfContent=JSON.parse(window.erStaticData).accordions[0].accordionList[0].accordionrte;	
                        } else {
                                pdfContent = null;//empty data
                }
                
                localStorage.removeItem("PDFContent");
                localStorage.setItem('PDFContent',pdfContent);
            }
        openDialog(e) {
		if (document.querySelector('.show_spinner') !== null) {
			document.querySelector('.show_spinner').classList.remove('show_spinner');
		}
		this.dialogRef.current.querySelector('.modal_content').innerHTML = "";
		this.dialogRef.current.querySelector('.modal_content').classList.remove("custompopup");
		let dialogContent = "";
                if (e !== null && e !== undefined) {
			dialogContent = (e.target.innerHTML === "View Store Location" || e.target.innerHTML.indexOf('locations') > -1) ? this.updateDialogContent("storelocations") : (e.target.innerHTML === "Unreturned Equipment Pricing")
				? this.state.NEED_TO_KNOW_CONTENT : (e.target.innerHTML === "What is my order number?") ? ORDER_NUMBER_CONTENT : "";
		} else {
			dialogContent = this.printLabelContent;
		}
                this.dialogRef.current.querySelector('.modal_content').innerHTML = dialogContent;
		this.dialogRef.current.classList.remove('hide_dialog');
		this.dialogRef.current.classList.add('active', "position_fixed");
		document.getElementsByClassName('page-overlay')[0].classList.remove('hide_dialog');
		document.getElementsByClassName('page-overlay')[0].classList.add('active');
		setTimeout(() => {
			this.dialogRef.current.querySelector('.modal_x').focus();
		
		}, 300);  

	}
        closeDialog(e) {
		console.log("closedialog ---1");
		this.dialogRef.current.classList.add('hide_dialog');
		this.dialogRef.current.classList.remove('active', "position_fixed");
		document.getElementsByClassName('page-overlay')[0].classList.add('hide_dialog');
		document.getElementsByClassName('page-overlay')[0].classList.remove('active');

                var preview = document.querySelectorAll ("#aOrderNumber");
                if(preview.length > 0){
                 preview[0].setAttribute("tabIndex", "0"); 
                 document.querySelector('#aOrderNumber').focus();
                }
	}
        convertStringToObject(data) {
            if (!isNullOrUndefined(data) && data !== "" && typeof (data) === "string") {
                return JSON.parse(data);
            } else if (isNullOrUndefined(data) || data === "") {
                return {};
            } else return data;
        }
        ufdSuccessCallback(output, template, json) {
            this.printLabelContent = output;
            this.openDialog(null);
        }
        ufdFailureCallBack(output, template, json) {
            this.printLabelContent = output;
            this.openDialog(null);
        }
        updateDialogContent(dialogType) {
            if (dialogType === "storelocations") {
                let orderDetails = this.state.signInDynamicData.orderDetails;
                this.dialogRef.current.querySelector('.modal_content').classList.add("custompopup");
                if (!isNullOrUndefined(orderDetails) && !isNullOrUndefined(orderDetails.Address1) && !isNullOrUndefined(orderDetails.Address2) && !isNullOrUndefined(orderDetails.Address3)) {
                    let content = "<h4 class='text-grey-2-active'>View store locations</h4><p>Since you chose to drop off your equipment, here are the three locations closest to your address. Just make sure you return any Verizon-owned within the next 30 days to avoid being billed an unreturned equipment charge.</p>" +
                        "<div class='bold'>Your nearest stores:</div><ul class='tiny-block-grid-1 medium-block-grid-3 margin-top-medium store-location'><li><div class='uppercase'>" +
                        orderDetails.Address1 + "<br/>" + orderDetails.ContactHours1 + "<br/></div></li><li class='medium-border-vert'><div class='uppercase'>" + orderDetails.Address2 + "<br/>" + orderDetails.ContactHours2 + "<br/></div></li><li><div class='uppercase'>" +
                        orderDetails.Address3 + "<br/>" + orderDetails.ContactHours3 + "<br/></div></li></ul><p>View any other store locations: <a class='bold' style='color: #000' href='https://www.verizon.com/home/storelocator' target='_blank' data-track='store locator'>www.verizon.com/home/storelocator</a></p></div>";
                    return content;
                } else {
                    return "<p>No nearest store location details available.<p>";
                }
            }
        }
        EQhandleKeyAction(e) {
                console.log("closedialog ---12")
                        if((e.target.classList.contains('modal_header') && e.keyCode === 13) || e.keyCode === 27) {
                           this.closeDialog(e);
                }
        
                //Focus trap inside modal overlay - keyboard accessibility fix       
                var selection = document.querySelector('#EquipmentPopupId') !== null;
                if (selection) {
                                console.log("closedialog ---13")
                    const  focusableElements = 'button, [href], li:not(.hide-content), input, select, textarea, [tabindex]:not([tabindex="-1"])';
                    const modal = document.querySelector('#EquipmentPopupId');
                    const focusable = modal.querySelectorAll(focusableElements);
                    const firstFocusable = focusable[0];
                    const lastFocusable = focusable[focusable.length - 1];
        
                    if (e.ctrlKey || e.altKey) {
                        return;
                    }
        
                    const keys = {
                        9: () => { //9 = TAB
                            if (e.shiftKey && e.target === firstFocusable) {
                                lastFocusable.focus();
                            }
        
                            if (e.target === lastFocusable) {
                                firstFocusable.focus();
                                e.preventDefault();
                            }
                        }
                    };
        
                    if (keys[e.keyCode]) {
                        keys[e.keyCode]();
                    }
                }
               
            }
            render() {
                let navpath ="/support/"+window.domain_url+"/EquipmentReturnPDF";
                let effectivevalue = (this.isValidUser)  ? JSON.parse(window.erStaticData).ntklist[0].date : "Effective";
                let effectivetext =  "Unreturned equipment pricing " + effectivevalue;
                let effectivevalue1 = ((this.isValidUser == true) && (JSON.parse(window.erStaticData).ntklist[0].date != "")) ? JSON.parse(window.erStaticData).ntklist[0].date : "Effective:"
                let effectivetext1 =  "Unreturned equipment pricing " + effectivevalue1;
                if (!this.isDropOffPage && this.state.validUser) {
			    return (
                                <React.Fragment> 
                                <ErrorBoundary>
                                <Header />
                                </ErrorBoundary>
                                <main role="main"> 
                                   <div className="container">                                        
                                        <div className="Helorow">
                                                <h1 className="erHeader" ariaLabel="Equipment Return Status" size="large" viewport="mobile">
                                                        Equipment return status
                                                </h1>
                                        <StyledSubcontent>
                                                <div className="erBodyContent" primitive="p" ariaLabel="We are unable to locate your order details. Please check if information was entered correctly" 
                                                size="small"  viewport="mobile">
                                                 We are unable to locate your order details.Please check if the information was entered correctly.
                                                <br/>
                                                <br/>
                                                If you need store locations,&nbsp; 
                                                <a href={this.getERStorelocatorUrl()} data-track="Store locator link">click here</a>. 
                                                For additional help, click on the Chat button.
                                                </div>
                                        </StyledSubcontent>
                                        <StyledLine>
                                                 <Line />
                                        </StyledLine>                                   
                                    </div>     
                                                <div className="NeedtoKnow">
                                                        <h2 className="erSubHeader" ariaLabel="Need to know" size="large" viewport="mobile">
                                                           Need to know
                                                        <span className="CaretArrow"> 
                                                                <img src={this.CalendarImage} alt=" " aria-hidden="true" ></img>
                                                        </span>
                                                        </h2>
                                                        <StyledSubcontent>
                                                                <div className="erBodyContent" primitive="p" ariaLabel="To avoid being billed an unreturned equipment charge, please return all your 
                                                                Verizon Fios equipment within 30 days of the day your service is disconnected." 
                                                                size="small"  viewport="mobile">
                                                                To avoid being billed an unreturned equipment charge, please return all your Verizon Fios equipment within 
                                                                30 days of the day your service is disconnected.
                                                                </div>
                                                        </StyledSubcontent>
                                                 </div>
                                                 <div className="Helorow" > 
                                                        <StyledLineLight>
                                                        <Line type="xLight"/>
                                                        </StyledLineLight>
                                                </div>
                                                <a href={navpath} onClick={this.PDFViewer.bind(this)}  aria-describedby={effectivetext} data-track="Unreturned equipment pricing Effective" className="removelink">
                                                <div className="erRow" >
                                                        <div flex="true" className="maincontentflex">
                                                                <img src={this.PDFImage} alt=" " aria-hidden="true" className="pdficonClass"></img>
                                                                <MainContainer >
                                                                <StyledMainContent>
                                                                        <div size="small" className="erEffective" ariaHidden={true} viewport="mobile" flex="true">
                                                                        {effectivetext}
                                                                        </div>
                                                                </StyledMainContent>
                                                                </MainContainer>
                                                        </div> 
                                                        <div className="CarretArroicon">
                                                                <span className="CaretArrow"> 
                                                                        <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                                                                </span>
                                                        </div>
                                                 </div> 
                                                 </a> 
                                                 <div className="Helorow" > 
                                                        <StyledLineLight>
                                                        <Line type="xLight"/>
                                                        </StyledLineLight>
                                                 </div>  
                                        </div>           
                               </main>
                               <ErrorBoundary>
                                 <Footer />
                               </ErrorBoundary>
                               <ErrorBoundary>
                                        <EQReturnModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} EQhandleKeyMethod={this.EQhandleKeyAction.bind(this)}>
                                        </EQReturnModalDialog>
                               </ErrorBoundary>
                               <input type="hidden" value={(this.isValidUser) ? "Auth" : "UnAuth"} id="loginType" />
                               <ErrorBoundary>
                                  <SiteCatalyst PageDetails={JSON.parse(window.erStaticData).pagedetails} />
                                </ErrorBoundary>
                </React.Fragment>   
                )
                }
                else if(this.isDropOffPage && this.state.validUser){
                        return (
                                <React.Fragment> 
                                    <ErrorBoundary>
                                        <Header />
                                    </ErrorBoundary>
                                <main role="main">
                                    <div className="container">   
                                        <div className="Helorow">
                                                 <h1 className="erHeader" ariaLabel="Equipment Return Status" size="large" viewport="mobile">
                                                        Equipment return status
                                                 </h1>
                                        <div className="margin-bottom-tiny">
                                        <p className="margin-bottom-tiny">Please return the following Verizon equipment before
                                            <b> {this.state.signInDynamicData.equipDetails[0].ReturnDueDate} </b>
                                            to avoid unreturned equipment charges. Take your equipment to
                                            <a className="bold link-text" onClick={this.openDialog.bind(this)}
                                                data-track="nearest drop off locations"> nearest drop off locations. </a>
                                            <a className="bold link-text" href={this.getStorelocatorUrl()}
                                                data-track="Click here for locations"> Click here for locations</a>
                                        </p>
						                </div>
                                                <StyledLine>
                                                        <Line />
                                                </StyledLine> 
                                        </div>
                                        <div className="NeedtoKnow">
                                            <h2 className="erSubHeader" ariaLabel="Need to know" size="large" viewport="mobile">
                                                   Need to know
                                                <span className="CaretArrow"> 
                                                    <img src={this.CalendarImage} alt=" " aria-hidden="true" ></img>
                                                </span>
                                            </h2>
											<StyledSubcontent>
												<div className="erBodyContent" primitive="p" ariaLabel="To avoid being billed an unreturned equipment charge, please return all your 
												Verizon Fios equipment within 30 days of the day your service is disconnected." 
												size="small"  viewport="mobile">
												To avoid being billed an unreturned equipment charge, please return all your Verizon Fios equipment within 
												30 days of the day your service is disconnected.
												</div>
                                			</StyledSubcontent>
										</div>
										<div className="Helorow" > 
												<StyledLineLight>
												<Line type="xLight"/>
												</StyledLineLight>
                            			</div> 
										<a href={navpath} onClick={this.PDFViewer.bind(this)}  aria-describedby={effectivetext} data-track="Unreturned equipment pricing Effective" className="removelink">
                            			<div className="erRow" >
											<div flex="true" className="maincontentflex">
												<img src={this.PDFImage} alt=" " aria-hidden="true" className="pdficonClass"></img>
												<MainContainer >
												<StyledMainContent>
													<div size="small" className="erEffective" ariaHidden={true} viewport="mobile" flex="true">
													{effectivetext}
													</div>
												</StyledMainContent>
												</MainContainer>
											</div>
											<div className="CarretArroicon">
                                    			<span className="CaretArrow"> 
                                        			<img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                                   				</span>
                                			</div> 
										</div> 
                            			</a>  
										<div className="Helorow" > 
											<StyledLineLight>
											<Line type="xLight"/>
											</StyledLineLight>
                            			</div>
									</div>              
                				</main> 
								<ErrorBoundary>
									<Footer />
								</ErrorBoundary>
								<ErrorBoundary>
									<EQReturnModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} EQhandleKeyMethod={this.EQhandleKeyAction.bind(this)}>
									</EQReturnModalDialog>
								</ErrorBoundary>
								<input type="hidden" value={(this.isValidUser) ? "Auth" : "UnAuth"} id="loginType" />
								<ErrorBoundary>
									<SiteCatalyst PageDetails={JSON.parse(window.erStaticData).pagedetails} />
								</ErrorBoundary>
							</React.Fragment>
			)
                                        
        }

	}
}
export default EquipmentReturnPageOneApp



// WEBPACK FOOTER //
// ./src/components/EquipmentReturnPageOneApp.js